export const brl = (v) =>
  (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 2, maximumFractionDigits: 2 });

// UI-1 (item 2) — abreviação para espaços pequenos (celular):
// "R$ 237 mil", "R$ 1,31 mi". Sempre exponha o valor exato em `title`/tooltip
// usando `brl()` para não esconder centavos.
export const brlShort = (v) => {
  const n = Number(v) || 0;
  const abs = Math.abs(n);
  const sign = n < 0 ? "-" : "";
  if (abs >= 1_000_000) return `${sign}R$ ${(abs / 1_000_000).toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} mi`;
  if (abs >= 1_000) return `${sign}R$ ${(abs / 1_000).toLocaleString("pt-BR", { maximumFractionDigits: 0 })} mil`;
  return brl(n);
};

// Mesma lógica, mas sempre com vírgula para percentuais ("108,3%").
export const pctBR = (v, d = 1) => {
  const n = Number(v);
  if (n == null || Number.isNaN(n)) return "—";
  return `${n.toLocaleString("pt-BR", { minimumFractionDigits: d, maximumFractionDigits: d })}%`;
};

export const brlFull = (v) =>
  (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const num = (v) => (Number(v) || 0).toLocaleString("pt-BR");

export const pct = (v, d = 0) => `${(Number(v) || 0).toLocaleString("pt-BR", { minimumFractionDigits: d, maximumFractionDigits: d })}%`;

export const initials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((n) => n[0])
    .join("")
    .toUpperCase() || "?";

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return "—";
  }
};

// Formatador de data SEM fuso — usa só os 10 primeiros caracteres do ISO
// (AAAA-MM-DD) e devolve DD/MM/AAAA. Nunca aplica timezone, não converte.
// Pedido CRM-008 do Lote 1: evitar "um dia antes" em `data_prevista`.
export const fmtDataPrevista = (iso) => {
  if (!iso) return "—";
  const s = String(iso).slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return "—";
  const [y, m, d] = s.split("-");
  return `${d}/${m}/${y}`;
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pt-BR", {
      day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return "—";
  }
};

export const fmtDateInput = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toISOString().slice(0, 10);
  } catch {
    return "";
  }
};

export const roleLabel = (role) =>
  ({
    admin: "Administrador",
    diretor_geral: "Diretor Geral",
    director: "Diretor",
    manager: "Gerente",
    seller: "Vendedor",
    logistica_adm: "Adm Logístico",
    tv_corporativa: "TV Corporativa",
  }[role] || "Vendedor");

export const STAGES = ["Prospecção", "Qualificação", "Testes", "Proposta", "Negociação", "Fechado", "Perdido"];

// Item 4.12 do lote 4 — apenas rótulo visual; a chave no banco continua "Fechado".
export const STAGE_LABELS = {
  "Fechado": "Ganho",
};
export const stageLabel = (stage) => STAGE_LABELS[stage] || stage;

export const stageColor = (stage) =>
  ({
    "Prospecção": "bg-slate-100 text-slate-700",
    "Qualificação": "bg-info-soft text-info",
    "Testes": "bg-brand-soft text-brand-hover",
    "Proposta": "bg-amber-100 text-amber-800",
    "Negociação": "bg-gold/20 text-[#8a6410]",
    "Fechado": "bg-ok-soft text-ok",
    "Perdido": "bg-bad-soft text-bad",
  }[stage] || "bg-slate-100 text-slate-700");

export const MANDALA = {
  1: "Diagnóstico + Processos",
  2: "Produtos profissionais",
  3: "Treinamento + Conscientização",
  4: "Gestão + Controle",
};

// Plural correto em pt-BR — sem "(s)". Uso: `plural(n, "ponto")` ou
// `plural(n, "concluída", "concluídas")` quando o plural não é +s.
export const plural = (n, singular, pluralForma) => {
  const palavra = n === 1 ? singular : (pluralForma || singular + "s");
  return `${num(n)} ${palavra}`;
};

// Added by deployment fix - fmtBRL function
export function fmtBRL(value) {
  if (value === null || value === undefined || value === "") return "R$ 0,00";
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "R$ 0,00";
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num);
}
